import React, { FC } from 'react';

import { Flex, Skeleton, Stack, Text } from '@chakra-ui/react';

import { selectors } from 'store/slices/washhub';

import { scrollbarStyles } from 'theme';

import { useQuery } from 'react-query';
import { getPackagesBySKU } from 'api/order';

import { PackagesListProps } from './PackagesList.props';

const usePackagesQuery = () => {
  const washHubId = selectors.useSelectedWashHubId();
  const queryKey = ['fetch-packages', washHubId];
  const queryFn = () => getPackagesBySKU(washHubId);

  const query = useQuery(queryKey, queryFn, {
    refetchOnMount: 'always',
  });

  return query;
};

const PackagesListView: FC<PackagesListProps> = (props) => {
  const { data, isFetching } = usePackagesQuery();

  const items = data || [];
  const isEmpty = items?.length === 0;

  const sortItems = (a: any, b: any) => {
    const nameA = String(a?.packageSku?.name || '').toLowerCase();
    const nameB = String(b?.packageSku?.name || '').toLowerCase();

    return nameA.localeCompare(nameB);
  };

  return (
    <Flex
      p="10px"
      pl="20px"
      minW="300px"
      h="100%"
      bg="#fff"
      minH="480px"
      maxH="480px"
      overflowY="auto"
      css={scrollbarStyles}
      flex={1}
      direction="column"
      borderRadius="10px"
      borderWidth="1px">
      <Text fontSize="22px" fontWeight="600" color="primary.200">
        Packages ({items.length ?? 0})
      </Text>

      <Flex mt="20px" bg="#E8F1EA" p="5px" fontWeight="600" color="primary.300">
        <Text flex={1}>SKU</Text>
        <Text flex={0.2} mx="15px">
          Ready
        </Text>
        <Text flex={0.2}>Requested</Text>
      </Flex>

      {isFetching ? (
        <Stack mt="20px">
          <Skeleton height="30px" />
          <Skeleton height="30px" />
          <Skeleton height="30px" />
          <Skeleton height="30px" />
          <Skeleton height="30px" />
          <Skeleton height="30px" />
          <Skeleton height="30px" />
        </Stack>
      ) : isEmpty ? (
        <Text>No Packages</Text>
      ) : (
        items.sort(sortItems).map((pack) => {
          return (
            <Flex
              p="5px"
              fontWeight="600"
              color="primary.300"
              borderBottom="1px solid #ccc"
              key={pack.packageSku?._id}>
              <Text flex={1}>{pack?.packageSku?.name || '-'}</Text>
              <Text flex={0.2} mx="15px">
                {pack?.readyCount || '0'}
              </Text>
              <Text flex={0.2}>{pack?.requestedCount || '0'}</Text>
            </Flex>
          );
        })
      )}
    </Flex>
  );
};

export default PackagesListView;
